export enum FeeStatusEnum {
  SUBMITTED = 'SUBMITTED',
  VALIDATED = 'VALIDATED',
  REFUSED = 'REFUSED',
  CANCELLED = 'CANCELLED',
  SA_MODERATION = 'SA_MODERATION'
}
